import { get } from '@/services/get'
import { JobStageApplication } from '@/types/application/job-stages'

export function getApplicationJobStages(applicationId: string) {
  return get<JobStageApplication>(`/applications/${applicationId}/job-stages`)
}
